angular.module('natgeo').directive('svgDropshadow', 
function svgDropshadow()
{
  return {
    templateUrl: 'templates/svg-dropshadow.html'
  }
})